// (function () {
// 	'use strict';

//     angular.module("imApp").factory("sellerService", ['$ihttp', function ($ihttp) {
// 		let service = {
//             getSeller: function (parms) {
//                 return $ihttp.post({
//                     method: 1387,
//                     parameters: parms || {}
//                 });
//             },
//             sellerLookup: function (parms) {
//                 return $ihttp.post({
//                     method: 2783,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 1388,
//                     parameters: edit
//                 });
//             }
// 		};

// 		return service;
// 	}]);
// })();
